import * as THREE from 'three';
import IMOG from '~/lib/imog';
import useWindowSize from '~/lib/imog/use/windowSize';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const v = new THREE.Vector3();

export default IMOG.Component('OrbitCamera', {
  options: {
    helpers: false,
    maxPolarAngle: Math.PI * 0.52,
    minPolarAngle: Math.PI * 0.15,
    extraControls: true,
  },

  props() {
    return {
      active: true,
      windowSize: useWindowSize(),
      size: (props) => ({
        width: props.windowSize.width,
        height: props.windowSize.height,
      }),
    };
  },

  setup({ options }) {
    this.camera = new THREE.PerspectiveCamera(40, 1, 0.1, 200);
    // this.cameraRef = new THREE.PerspectiveCamera(20, 1, 2, 50);

    IMOG.inject('worldCamera', this.camera);
  },

  methods: {
    init() {
      const { maxPolarAngle, minPolarAngle, extraControls } = this.options;
      this.camera.position.set(0, 4, 8);
      this.camera.position.multiplyScalar(2.5);
      this.controls = new OrbitControls(this.camera, this.$renderer.domElement);
      IMOG.inject('orbitControls', this.controls);
      this.controls.target.set(0, 2, 0);
      this.controls.enableDamping = true;
      this.controls.dampingFactor = 0.15;
      if (!extraControls) {
        this.controls.enableZoom = false;
      }
      // this.controls.enablePan = false;

      this.controls.minDistance = 8;
      this.controls.maxDistance = 40;

      this.controls.maxPolarAngle = maxPolarAngle;
      this.controls.minPolarAngle = minPolarAngle;
    },
  },

  hooks: {
    'set:size'({ width, height, pr }) {
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    },
    'while:active'() {
      if (this.controls) {
        if (this.$spider) {
          this.$spider.bones.Base.getWorldPosition(v);
          this.controls.target.lerp(v, 0.02);
        }
        this.controls.update();
      }
    },
  },
});
